import axios from 'axios';

export async function getTestOptions(): Promise<{
  testTypes: App.Base.Data.EnumData[];
}> {
  return axios.get(route('api.tests.options')).then((res) => res.data);
}
